// Hook to get display title with reactive updates when preference changes

import { useTitlePreference } from '../context/TitlePreferenceContext';

/**
 * Get display title for anime (respects user preference: English or Romanji)
 * This is a React hook version that reactively updates when preference changes
 * @param {Object} anime - Anime object with title
 * @returns {string} Display title
 */
export const useDisplayTitle = (anime) => {
    const { titlePreference } = useTitlePreference();

    if (!anime || !anime.title) return 'Unknown';

    if (titlePreference === 'romanji') {
        return anime.title.romaji || anime.title.english || anime.title.native || 'Unknown';
    }

    // Default: English with fallback to Romanji
    return anime.title.english || anime.title.romaji || anime.title.native || 'Unknown';
};

/**
 * Non-hook version for use in services (reads from localStorage)
 * @param {Object} anime - Anime object with title
 * @param {string} preference - Optional preference override  
 * @returns {string} Display title
 */
export const getDisplayTitle = (anime, preference = null) => {
    if (!anime || !anime.title) return 'Unknown';

    const pref = preference || localStorage.getItem('anime_name_preference') || 'english';

    if (pref === 'romanji') {
        return anime.title.romaji || anime.title.english || anime.title.native || 'Unknown';
    }

    // Default: English with fallback to Romanji
    return anime.title.english || anime.title.romaji || anime.title.native || 'Unknown';
};
